routesConfig.$inject = ['$stateProvider']

function routesConfig($stateProvider) {
  $stateProvider
    .state('home.byFavorites', {
      url: "compra-rapida/carga-rapida-por-favoritos",
      template: `<by-favorites sh-ctrl="shCtrl"></by-favorites>`
    })
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/by-favorites/by-favorites.config.js
 **/